/**
 * Browser configuration embedded by React during the frontend build.
 *
 * These values identify the GCP Identity Platform project. They are public
 * client configuration, not credentials or secrets.
 */
export const IDENTITY_PLATFORM_CONFIG = Object.freeze({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_GCP_PROJECT_ID,
});

export const SHIBBOLETH_PROVIDERS_CONFIGURATION = process.env.REACT_APP_SHIBBOLETH_PROVIDERS;
export const PORTAL_ACCESS_ENTITLEMENTS = process.env.REACT_APP_PORTAL_ACCESS_ENTITLEMENTS;
export const IMPERSONATION_ENTITLEMENTS = process.env.REACT_APP_IMPERSONATION_ENTITLEMENTS;
export const IMPERSONATION_HEADER = 'X-MSS-Impersonate-User';

/**
 * Environment settings required before the Shibboleth flow can start.
 */
export const REQUIRED_IDENTITY_CONFIGURATION = Object.freeze({
  REACT_APP_FIREBASE_API_KEY: IDENTITY_PLATFORM_CONFIG.apiKey,
  REACT_APP_FIREBASE_AUTH_DOMAIN: IDENTITY_PLATFORM_CONFIG.authDomain,
  REACT_APP_GCP_PROJECT_ID: IDENTITY_PLATFORM_CONFIG.projectId,
  REACT_APP_SHIBBOLETH_PROVIDERS: SHIBBOLETH_PROVIDERS_CONFIGURATION,
  REACT_APP_PORTAL_ACCESS_ENTITLEMENTS: PORTAL_ACCESS_ENTITLEMENTS,
  REACT_APP_IMPERSONATION_ENTITLEMENTS: IMPERSONATION_ENTITLEMENTS,
});

export const AUTH_STATUS = Object.freeze({
  CHECKING: 'checking',
  SIGNED_IN: 'signedIn',
  SIGNED_OUT: 'signedOut',
  DENIED: 'denied',
});

/**
 * Attribute names released by ODU Shibboleth in the Identity Platform token.
 */
export const SAML_ATTRIBUTE_NAMES = Object.freeze({
  DISPLAY_NAME: 'urn:oid:2.16.840.1.113730.3.1.241',
  EMAIL: 'urn:oid:0.9.2342.19200300.100.1.3',
  ENTITLEMENTS: 'urn:oid:1.3.6.1.4.1.5923.1.1.1.7',
  FAMILY_NAME: 'urn:oid:2.5.4.4',
  GIVEN_NAME: 'urn:oid:2.5.4.42',
  ROLES: 'urn:odu:role',
});
